import { TreatyDetailsFragment } from './../../graphql/generated';
import { createTreatyLabelMap } from './create-treaty-label-map';

/**
 * Converts an array of cedants into its corresponding names
 */
export const convertCedantsToCedantNames = (
  cedantsToConvert: string[],
  cedantDetails: TreatyDetailsFragment[]
) => {
  const cedantLabelMap = createTreatyLabelMap(cedantDetails);
  return cedantsToConvert?.map((cedant) => cedantLabelMap[cedant] || cedant);
};
